import {customElement, property} from 'lit/decorators.js';
import {html} from 'lit';
import {FlywheelComponent} from '#lit/lib/component.js';
import FlyUserAvatar, {
  Shape as FlyUserAvatarShape,
} from '#lit/components/base/user_avatar/index.js';
import '#lit/components/base/icon/index.js';
import '#lit/components/base/dropdown/index.js';
import styles from './style.scss';

export const USER_MENU_ELEMENT_TAG = 'fly-user-menu';

/**
 * UserMenu -- Description here
 */
@customElement(USER_MENU_ELEMENT_TAG)
export default class UserMenu extends FlywheelComponent {
  @property()
  name = '';

  @property()
  profileURL = '';

  @property({type: Boolean})
  hideInfo = false;

  @property({type: Boolean})
  showDropdown = false;

  static get styles() {
    return [styles];
  }

  render() {
    return html`
      <div class="fly-user-menu">
        <slot name="announcements"> </slot>

        <fly-user-avatar
          shape=${FlyUserAvatarShape.ROUNDED}
          link=${this.profileURL}
          initials=${FlyUserAvatar.initialsFrom(this.name)}
        >
        </fly-user-avatar>
        <fly-dropdown
          ?active=${this.showDropdown}
          @closed=${() => {
            const timeout = setTimeout(() => {
              if (this.showDropdown) this.showDropdown = false;
              clearTimeout(timeout);
            }, 100);
          }}
        >
          <div
            class="fly-user-menu__info"
            slot="anchor"
            @click=${(e: MouseEvent) => {
              e.stopPropagation();
              this.showDropdown = !this.showDropdown;
            }}
          >
            <div class="fly-user-menu__info__name">${this.name}</div>
            <fly-icon icon="keyboard_arrow_down"> </fly-icon>
          </div>
          <div slot="surface">
            <fly-list slot="menu">
              ${this.profileURL
                ? html`
                    <a href="${this.profileURL}" aria-label="Go to Profile">
                      <fly-list-item>Profile</fly-list-item>
                    </a>
                  `
                : ''}
              <a href="/auth/logout" aria-label="Logout">
                <fly-list-item>Logout</fly-list-item>
              </a>
            </fly-list>
          </div>
        </fly-dropdown>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'fly-user-menu': UserMenu;
  }
}
